import React from "react";
import './footer.css'

const Footer = () => {
  return (
    <div style={{margin:"-112px 40px 0 0"}}>
      <div className="footer">
        <div className="footer-links">
          <a
            href="/terms"
            style={{
              display: "flex", // Aligns items in a row (horizontally)
              alignItems: "center", // Vertically aligns text and image
              textDecoration: "none", // Removes default underline
              fontSize: "16px", // Set a consistent font size for the text
            }}
          >
            <img
              src={require("../../assets/i-icon.svg").default}
              alt="refresh"
              style={{
                width: "20px", // Set a fixed width for the image
                height: "20px", // Set a fixed height for the image
                marginRight: "8px", // Space between image and text
              }}
            />
            About Us
          </a>
          <a
            href="/privacy"
            style={{
              display: "flex", // Aligns items in a row (horizontally)
              alignItems: "center", // Vertically aligns text and image
              textDecoration: "none", // Removes default underline
              fontSize: "16px", // Set a consistent font size for the text
            }}
          >
            <img
              src={require("../../assets/phone.svg").default}
              alt="refresh"
              style={{
                width: "20px", // Set a fixed width for the image
                height: "20px", // Set a fixed height for the image
                marginRight: "8px", // Space between image and text
              }}
            />
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};
export default Footer;
